import React, {Component} from 'react';
import { connect} from 'react-redux'
import {bindActionCreators, compose} from 'redux'
import CTable from '@/components/CTable'
import CInput from '@/components/CForm/CInput'
import CButton from '@/components/CButton'
import CBaseComponent from '@/components/CBaseComponent'
import { setReload } from "@/redux/common/action";
import { tableData} from './data'
import './index.scss'

import {withRouter} from "react-router-dom";
import {message, Modal} from "antd";
import 'react-multi-select-panel/index.css'
import {museumlist, usernormaldelete} from "../../../../servers/goodsManageApi";


@CBaseComponent
class GoodsManageList extends Component{
  constructor(props) {
    super(props);
    this.getListData = this.getListData.bind(this);
    this.addHandler = this.addHandler.bind(this);
    this.editHandler = this.editHandler.bind(this);
    this.onChange1 = this.onChange1.bind(this)
    this.resetHandler = this.resetHandler.bind(this)
    this.onTableChange = this.onTableChange.bind(this)
  }

  componentWillReceiveProps(nextProps) {
    // reload时重新加载数据
  }


  state = {
    columns: tableData.tHead,
    dataSource: tableData.tBody,
    dataSourceAll:[],
    page: tableData.tPage,
    addqx:[],
    museumname:'',
    loading: false,
    showoperate:true
  };

  // 获取用户列表数据
  getListData(){
    this.setState({
      loading: true
    });
    museumlist({name:this.state.museumname}).then(res=>{
      let d = JSON.parse(JSON.stringify(res.records[0].datalist))
      let  data = d.splice((this.state.page.page-1)*this.state.page.pageSize,this.state.page.page*this.state.page.pageSize)
      this.setState({
        dataSourceAll:res.records[0].datalist,
        dataSource: data,
        page:{...this.state.page,total:res.records[0].datalist.length},
        loading: false,
      });
    }).catch(err=>{
      console.log(err,'rttt')
    })
  }

  /*新增*/
  addHandler(){
    this.props.history.push({
      pathname: '/libraryadd',
      search: '?type=new'
    })
  }

  // 编辑当前行
  editHandler(data){
    sessionStorage.setItem('libraryEdit', JSON.stringify(data))
    this.props.history.push({
      pathname: '/libraryadd',
      search: `?type=edit`
    })
  }

  onDelete(data){
    Modal.confirm({
      content: '确认删除该博物馆',
      okText: '确认',
      cancelText: '取消',
      onOk:()=>{
        const params = {
          mimid:data
        }
        usernormaldelete(params).then(res=>{
          if (res.statecode === 0) {
            message.success('删除成功');
            this.getListData()
          } else {
            message.error('删除失败');
          }
        })
      }
    });
  }

  onTableChange(data){
    let d =this.state.dataSourceAll
    var bIndex = parseInt(data.data.pageSize) * (parseInt(data.data.page) - 1);
    var eIndex = parseInt(bIndex) + parseInt(data.data.pageSize);
    var newDataList = [];
    for(var i = bIndex;i < eIndex;i++){
      if (d[i]) {
        newDataList.push(d[i]);
      }
    }
    this.setState({
      page: {...this.state.page, ...data.data},
      dataSource:newDataList
    })
  }

  onChange1(data){
    this.setState({
      museumname:data
    })
  }

  resetHandler(){
    this.setState({
      museumname: ''
    },()=>{
      this.getListData()
    })

  }

  componentWillMount(){

  }

  componentDidMount(){
    this.getListData();
  }
  render(){
    return (
        <div className='user-manage-list'>
          <div className='flex filter-wrap'>
            <div className='flex filter-right'>
              <CButton type='primary' authId='goodsManageListNewAdd' onClick={this.addHandler}>新增</CButton>
            </div>
            <div className='flex filter-left'>
              <CInput value={this.state.museumname}
                      className='search-input'
                      type='search'
                      placeholder='请输入请输入博物馆名称'
                      onChange={this.onChange1}
              />
              <CButton type='primary' onClick={this.getListData}>查询</CButton>
              <CButton type='primary' onClick={this.resetHandler}>重置</CButton>
            </div>
          </div>
          <CTable ref='userManageList' checked={false} loading={this.state.loading} columns={this.state.columns}
                  dataSource={this.state.dataSource}
                  page={this.state.page}
                  onTableChange={this.onTableChange}

          >
            <div
                slot='index'
                render={(text, record, index) => (
                    <div className='operate'>
                      {index + 1}
                    </div>
                )}/>
            <div
                slot='operate'
                render={(text, record, index) => (
                    <div className='operate'>
                      <CButton type='text' authId='goodsManageListEdit'
                               onClick={() => this.editHandler(record)}>编辑</CButton>
                      <CButton type='text' authId='goodsManageListEdit' onClick={() => this.onDelete(record.id)}
                               style={{marginLeft: '20px'}}>删除</CButton>
                    </div>
                )}/>
          </CTable>
        </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    reload: state.reload,
  }
};

const mapDispatchToProps = (dispatch) => {
  return {
    setReload: bindActionCreators(setReload, dispatch)
  }
};

export default compose(withRouter, connect(mapStateToProps, mapDispatchToProps))(GoodsManageList);
